'use strict';

require("core-js/modules/es6.typed.uint8-array");

var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
  randomByte = function randomByte(size) {
    var bytes = [];

    for (var i = 0; i < size; i++) {
      bytes.push(Math.floor(Math.random() * 256));
    }

    return bytes;
  };
} else {
  randomByte = function randomByte(size) {
    return crypto.getRandomValues(new Uint8Array(size));
  };
}

module.exports = randomByte;